import type { RoutineStepTemplateRepository } from '../../../application/ports/RoutineStepTemplateRepository';
import type { RoutineStepTemplate } from '../../../domain/routine/models';
import type { RoutineStepTemplateId, RoutineTemplateId } from '../../../domain/shared/ids';
import type { AscendInvictusDatabase } from '../AscendInvictusDatabase';
import { RoutineStepTemplateMapper } from '../mappers';
import { executePersistence } from '../translatePersistenceError';

export class DexieRoutineStepTemplateRepository implements RoutineStepTemplateRepository {
  public constructor(private readonly database: AscendInvictusDatabase) {}

  public save(step: RoutineStepTemplate): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.routineStepTemplates.put(RoutineStepTemplateMapper.toRecord(step));
    });
  }

  public findById(id: RoutineStepTemplateId): Promise<RoutineStepTemplate | null> {
    return executePersistence('read', async () => {
      const record = await this.database.routineStepTemplates.get(id);
      return record ? RoutineStepTemplateMapper.fromRecord(record) : null;
    });
  }

  public listByTemplate(templateId: RoutineTemplateId): Promise<readonly RoutineStepTemplate[]> {
    return executePersistence('read', async () => {
      const records = await this.database.routineStepTemplates
        .where('routineTemplateId')
        .equals(templateId)
        .sortBy('order');
      return records.map((record) => RoutineStepTemplateMapper.fromRecord(record));
    });
  }

  public delete(id: RoutineStepTemplateId): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.routineStepTemplates.delete(id);
    });
  }
}
